import { DateTime } from 'luxon'

export const consumptionItemKey = 'yyyyMMddHHmm'

type Item = { [yyyyMMddHHmm: string]: number }

export type ConsumptionData = {
  currentConsumption: number
  co2Emission: number
  items: Item
}

export default class Consumption {
  declare currentConsumption: number
  declare co2Emission: number
  declare items: Item

  constructor(params: ConsumptionData) {
    Object.assign(this, params)
  }

  getItem(date: DateTime): number | null {
    return this.items[date.toFormat(consumptionItemKey)] ?? null
  }
}
